module.exports = __webpack_public_path__ + "img/1F1F8-1F1E9.57e5bfcc.svg";